module.exports = __webpack_public_path__ + "static/media/T14-T25-06.840c1ada.svg";